// import React, { useEffect, useState } from 'react'
// import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap'
// import axios from 'axios'
// import toast from 'react-hot-toast'
// import Cookies from 'js-cookie'
// import { useNavigate } from 'react-router-dom'

// const Customer = ({ onCustomerCreated }) => {
//   const [customer, setCustomer] = useState({
//     title: '',
//     name: '',
//     guardian_title: '',
//     guardian_name: '',
//     email: '',
//     phone_number: '',
//     city: '',
//     state: '',
//     pincode: '',
//     address: '',
//     id_type: '',
//     id_number: '',
//   })
//   const [showModal, setShowModal] = useState(false)
//   const navigate = useNavigate()
//   const validTitles = ['Mr', 'Mrs', 'Dr']
//   const validGuardianTitles = ['Mr', 'Mrs', 'Dr']
//   const validIdTypes = ['AADHAR CARD', 'PAN CARD', 'LICENSE']
//   const validStates = ['DELHI', 'UTTAR PRADESH', 'BIHAR']

//   const [error, setError] = useState('')
//   const [loading, setLoading] = useState(false)
//   useEffect(() => {
//     // Check for authentication token
//     const token = Cookies.get('authToken')
//     if (!token) {
//       // If token is not found, redirect to login page
//       window.location.href = '/login'
//     }
//   }, [])

//   const inputHandler = (e) => {
//     const { name, value } = e.target
//     setCustomer({ ...customer, [name]: value })
//     console.log(customer)
//   }

//   const submitForm = async (e) => {
//     e.preventDefault()
//     setError('')
//     setLoading(true)

//     const token = Cookies.get('authToken')

//     // Validate ID type selection
//     if (!customer.title) {
//       toast.error('Please select a customer title')
//       setLoading(false)
//       return
//     }
//     if (!validTitles.includes(customer.title)) {
//       toast.error('Invalid customer title selected')
//       setLoading(false)
//       return
//     }

//     if (!customer.guardian_title) {
//       toast.error("Please select the guardian's title")
//       setLoading(false)
//       return
//     }
//     if (!validGuardianTitles.includes(customer.guardian_title)) {
//       toast.error('Invalid guardian title selected')
//       setLoading(false)
//       return
//     }

//     if (!customer.id_type) {
//       toast.error('Please select an ID type')
//       setLoading(false)
//       return
//     }
//     if (!validIdTypes.includes(customer.id_type)) {
//       toast.error('Invalid Id Type selected')
//       setLoading(false)
//       return
//     }

//     if (!customer.state) {
//       toast.error('Please select a state')
//       setLoading(false)
//       return
//     }
//     if (!validStates.includes(customer.state)) {
//       toast.error('Invalid State selected')
//     }
//     try {
//       const response = await axios.post(
//         BASE_URL+'/customer/create',
//         customer,

//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       )
//       // toast.success(response.data.message || 'Customer created successfully ')

//       setShowModal(true)
//       setTimeout(() => {
//         navigate('/customerlists')
//         window.location.reload()
//       }, 3000)
//     } catch (err) {
//       toast.error(
//         err.response?.data.message ||
//           'Failed to create customer. Please try again.',
//       )
//     }
//     console.log(customer)
//   }

//   const handleModalClose = () => {
//     setShowModal(false)
//   }
//   return (
//     <Container
//       style={{ maxWidth: '1099px', marginRight: '13.5rem' }}
//       className="mt-0 p-0"
//     >
//       <Form className="text-start m-0  p-0" onSubmit={submitForm}>
//         <h1
//           className="display-6 text-success bg-light fw-bold text-center p-1"
//           style={{
//             borderBottom: '1px solid gray',
//           }}
//         >
//           Create New Customer
//         </h1>
//         <Row>
//           <Col md={2} className="mb-3 ">
//             <Form.Label htmlFor="title">
//               Title
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Select
//               id="title"
//               name="title"
//               value={customer.title}
//               onChange={inputHandler}
//               required
//             >
//               <option value="">SELECT</option>
//               <option value="Mr">Mr.</option>
//               <option value="Mrs">Mrs.</option>
//               <option value="Dr">Dr.</option>
//             </Form.Select>
//           </Col>

//           <Col md={4} className="mb-3 ">
//             <Form.Label htmlFor="name">
//               Name
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               id="name"
//               name="name"
//               value={customer.name}
//               onChange={inputHandler}
//               required
//             />
//           </Col>

//           <Col md={2} className="mb-3 ">
//             <Form.Label htmlFor="guardian_title">
//               Title
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Select
//               id="guardian_title"
//               name="guardian_title"
//               value={customer.guardian_title}
//               onChange={inputHandler}
//               required
//             >
//               <option value="">SELECT</option>
//               <option value="Mr">Mr.</option>
//               <option value="Mrs">Mrs.</option>
//               <option value="Dr">Dr.</option>
//             </Form.Select>
//           </Col>
//           <Col md={4} className="mb-3 ">
//             <Form.Label htmlFor="guardian_name">
//               Guardian's Name
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               id="guardian_name"
//               name="guardian_name"
//               value={customer.guardian_name}
//               onChange={inputHandler}
//               required
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={6} className="mb-3 ">
//             <Form.Label htmlFor="email">
//               Email
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="email"
//               id="email"
//               name="email"
//               value={customer.email}
//               onChange={inputHandler}
//               required
//             />
//           </Col>
//           <Col md={6} className="mb-3 ">
//             <Form.Label htmlFor="phone_number">
//               Phone Number
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="tel"
//               id="phone_number"
//               name="phone_number"
//               value={customer.phone_number}
//               onChange={inputHandler}
//               required
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={4} className="mb-3 ">
//             <Form.Label htmlFor="state">
//               State
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Select
//               id="state"
//               name="state"
//               value={customer.state}
//               onChange={inputHandler}
//               required
//             >
//               <option value="">SELECT</option>
//               <option value="DELHI">DELHI</option>
//               <option value="UTTAR PRADESH">UTTAR PRADESH</option>
//               <option value="BIHAR">BIHAR</option>
//             </Form.Select>
//           </Col>

//           <Col md={4} className="mb-3 ">
//             <Form.Label htmlFor="city">
//               City
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               id="city"
//               name="city"
//               value={customer.city}
//               onChange={inputHandler}
//               required
//             />
//           </Col>

//           <Col md={4} className="mb-3 ">
//             <Form.Label htmlFor="pincode">
//               Pincode
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               id="pincode"
//               name="pincode"
//               value={customer.pincode}
//               onChange={inputHandler}
//               required
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={12} className="mb-3 ">
//             <Form.Label htmlFor="address">
//               Address
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               as="textarea"
//               id="address"
//               name="address"
//               value={customer.address}
//               onChange={inputHandler}
//               required
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={6} className="mb-3 text-start">
//             <Form.Label htmlFor="id_type">
//               ID Type
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Select
//               id="id_type"
//               name="id_type"
//               value={customer.id_type}
//               onChange={inputHandler}
//               required
//             >
//               <option value="">SELECT</option>
//               <option value="AADHAR CARD">AADHAR CARD</option>
//               <option value="PAN CARD">PAN CARD</option>
//               <option value="LICENSE">DRIVING LICENCE</option>
//             </Form.Select>
//           </Col>
//           <Col md={6} className="mb-3 text-start">
//             <Form.Label htmlFor="id_number">
//               ID Number
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               id="id_number"
//               name="id_number"
//               value={customer.id_number}
//               onChange={inputHandler}
//               required
//             />
//           </Col>
//         </Row>

//         {error && <div className="alert alert-danger">{error}</div>}
//         <div className="d-grid mt-4 ">
//           <Button
//             type="submit"
//             className="text-white"
//             style={{ backgroundColor: '#198754', border: 'none' }}
//             disabled={loading}
//           >
//             {loading ? 'Creating...' : 'Create New Customer'}
//           </Button>
//         </div>
//       </Form>

//       <Modal show={showModal} onHide={handleModalClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100 text-center">
//             Customer Created Successfully!
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>
//             The new customer has been added to the system successfully. You can
//             now view their details, manage their account, or proceed with the
//             next steps in the process.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="success" onClick={handleModalClose}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   )
// }

// export default Customer


import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Modal, Card } from 'react-bootstrap'
import axios from 'axios'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const Customer = ({ onCustomerCreated }) => {
  const [customer, setCustomer] = useState({
    title: '',
    name: '',
    guardian_title: '',
    guardian_name: '',
    email: '',
    phone_number: '',
    city: '',
    state: '',
    pincode: '',
    address: '',
    id_type: '',
    id_number: '',
  })

  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const validTitles = ['Mr', 'Mrs', 'Dr']
  const validGuardianTitles = ['Mr', 'Mrs', 'Dr']
  const validIdTypes = ['AADHAR CARD', 'PAN CARD', 'LICENSE']
  const validStates = ['DELHI', 'UTTAR PRADESH', 'BIHAR']

  useEffect(() => {
    const token = Cookies.get('authToken')
    if (!token) window.location.href = '/login'
  }, [])

  const inputHandler = (e) => {
    const { name, value } = e.target
    setCustomer((prev) => ({ ...prev, [name]: value }))
  }

  const submitForm = async (e) => {
    e.preventDefault()
    setLoading(true)

    const token = Cookies.get('authToken')

    // Basic validation
    if (!validTitles.includes(customer.title)) {
      toast.error('Please select a valid title')
      setLoading(false)
      return
    }
    if (!validGuardianTitles.includes(customer.guardian_title)) {
      toast.error('Please select a valid guardian title')
      setLoading(false)
      return
    }
    if (!validIdTypes.includes(customer.id_type)) {
      toast.error('Please select a valid ID Type')
      setLoading(false)
      return
    }
    if (!validStates.includes(customer.state)) {
      toast.error('Please select a valid State')
      setLoading(false)
      return
    }

    try {
      await axios.post(
        BASE_URL+'/customer/create',
        customer,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      )

      setShowModal(true)
      setTimeout(() => {
        navigate('/customerlists')
        window.location.reload()
      }, 3000)
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          'Failed to create customer. Please try again.'
      )
    } finally {
      setLoading(false)
    }
  }

  const handleModalClose = () => {
    setShowModal(false)
  }

  return (
<Container className="pb-3" style={{fontFamily: theme.font.family }}>

      <Form
        onSubmit={submitForm}
        className="mx-auto p-3 rounded-3"
        style={{
      
        
          backgroundColor: theme.colors.background,
      
        }}
      >
        <p
          className="mb-4 fw-bold"
          style={{
            color: theme.colors.primary,
            borderBottom: `2px solid ${theme.colors.secondary}`,
            paddingBottom: '8px',
            fontSize: '1.5rem',
          }}
        >
          Create New Customer
        </p>

        {/* Customer & Guardian Info */}
        <Row className="mb-3">
          <Col md={2}>
            <Form.Label>Title *</Form.Label>
            <Form.Select
              name="title"
              value={customer.title}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            >
              <option value="">Select</option>
              {validTitles.map((t) => (
                <option key={t} value={t}>
                  {t}.
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={4}>
            <Form.Label>Name *</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={customer.name}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            />
          </Col>
          <Col md={2}>
            <Form.Label>Guardian Title *</Form.Label>
            <Form.Select
              name="guardian_title"
              value={customer.guardian_title}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            >
              <option value="">Select</option>
              {validGuardianTitles.map((t) => (
                <option key={t} value={t}>
                  {t}.
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={4}>
            <Form.Label>Guardian's Name *</Form.Label>
            <Form.Control
              type="text"
              name="guardian_name"
              value={customer.guardian_name}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            />
          </Col>
        </Row>

        {/* Contact Info */}
        <Row className="mb-3">
          <Col md={6}>
            <Form.Label>Email *</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={customer.email}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            />
          </Col>
          <Col md={6}>
            <Form.Label>Phone Number *</Form.Label>
            <Form.Control
              type="tel"
              name="phone_number"
              value={customer.phone_number}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            />
          </Col>
        </Row>

        {/* Location Info */}
        <Row className="mb-3">
          <Col md={4}>
            <Form.Label>State *</Form.Label>
            <Form.Select
              name="state"
              value={customer.state}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            >
              <option value="">Select</option>
              {validStates.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={4}>
            <Form.Label>City *</Form.Label>
            <Form.Control
              type="text"
              name="city"
              value={customer.city}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            />
          </Col>
          <Col md={4}>
            <Form.Label>Pincode *</Form.Label>
            <Form.Control
              type="text"
              name="pincode"
              value={customer.pincode}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            />
          </Col>
        </Row>

        {/* Address */}
        <Row className="mb-3">
          <Col md={12}>
            <Form.Label>Address *</Form.Label>
            <Form.Control
              as="textarea"
              name="address"
              value={customer.address}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            />
          </Col>
        </Row>

        {/* ID Details */}
        <Row className="mb-3">
          <Col md={6}>
            <Form.Label>ID Type *</Form.Label>
            <Form.Select
              name="id_type"
              value={customer.id_type}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            >
              <option value="">Select</option>
              {validIdTypes.map((id) => (
                <option key={id} value={id}>
                  {id}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={6}>
            <Form.Label>ID Number *</Form.Label>
            <Form.Control
              type="text"
              name="id_number"
              value={customer.id_number}
              onChange={inputHandler}
              style={{ borderRadius: '6px' }}
            />
          </Col>
        </Row>

        {/* Submit Button */}
        <div className="d-grid mt-4">
          <Button
            type="submit"
            disabled={loading}
              className="fw-semibold py-2"
              style={{
                backgroundColor: theme.colors.primary,
                border: 'none',
                fontSize: '1.05rem',
              }}
          >
            {loading ? 'Creating...' : 'Create Customer'}
          </Button>
        </div>
      </Form>

      {/* Success Modal */}
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title
            className="text-center text-success w-100"
            style={{ fontWeight: 600 }}
          >
            Customer Created Successfully!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            The new customer has been added successfully. You can now view their
            details, manage their account, or proceed with the next steps.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleModalClose}
            style={{
              backgroundColor: '#4D5C2B',
              border: 'none',
              color: '#fff',
              borderRadius: '6px',
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default Customer
